const LOGOUT_PARAMS = ["forceLogout", "logoutConfirm"];

const hasLogoutParam = (search?: string) => {
  const params = new URLSearchParams(search);
  return LOGOUT_PARAMS.some((param) => params.has(param));
};

export default hasLogoutParam;
